<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialogDetails[modalProps.viewName]"
            transition="dialog-bottom-transition"
            @click:outside="closeDialog"
            scrollable
            :max-width="dialogWidth">
        <v-card class="grey lighten-4">
            <v-toolbar
            dark
            color="primary"
            >
                <v-toolbar-title v-text="item.Name"></v-toolbar-title>
                <v-btn
                    icon
                    dark
                    @click="closeDialog"
                    class="ml-auto"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-carousel
                v-if="item.ImgThumb && modalProps.showImage"
                :show-arrows="item.ImgThumb.length > 1" 
                hide-delimiters
                >
                <v-carousel-item
                    v-for="(th,i) in item.ImgThumb"
                    :height="imgHeight" 
                    :key="i">
                    <v-img
                        :src="th.url"
                        :height="'100%'" 
                        :position="'25%'">
                        <div class="d-flex align-start justify-end fill-height pa-3">
                            <v-chip small color="pink" class="mr-1" v-for="t in item.TagNames" v-text="t" :key="t"></v-chip>
                            <v-chip small color="pink darken-1" class="mr-1" v-for="a in item.Activities" v-text="a.toLowerCase()" :key="a"></v-chip>
                        </div>
                    </v-img>
                </v-carousel-item>
            </v-carousel>
            <v-card-title class="d-flex align-start justify-center pt-md-4 pt-3">
                <div class="headline text-truncate shrink" v-text="item.Short"></div>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-row class="my-0">
                    <v-col xl="10" lg="11" md="12" cols="12" class="mx-auto py-3">
                        <v-row align="center">
                            <v-col md="6" sm="5" cols="auto" order="last" order-sm="first" class="d-flex justify-end">
                                <mapbox-map 
                                    v-if="item.State"
                                    :location="item.Location"
                                    :token="'pk.eyJ1IjoiZHFpYTAwMDEiLCJhIjoiY2p0cGpoM3pkMDVhaDN5cXN1aTN0eDI5byJ9.tCL6OxJKJeGo6jJ2LKulyw'">
                                </mapbox-map>
                                <v-card
                                    v-else-if="item.ImgThumb && item.ImgThumb[0]"
                                >
                                    <v-card-text>
                                        <img 
                                        :style="{ width: '100%' }"
                                        :src="item.ImgThumb[0].url" />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col md="6" sm="7" cols="auto">
                                <div class="overline ml-auto text-truncate d-flex align-center grey--text" v-if="item.State">
                                    <v-icon small>mdi-map-marker-outline</v-icon>
                                    <span class="ml-1 text-truncate">{{ item.Location }}</span>
                                </div>
                                <p class="heading" v-text="item.Full"></p>
                            </v-col>
                            <v-col cols="10" class="d-none">
                                <h3>How long have you been hosting? Was there a memorable guest?</h3>
                                <h3>What makes this place interesting, unique and what inspired the style?</h3>
                                <h3>Do you consider it one-of-a-kind, and if so why?</h3>
                                <h3>What's the local area like, and what things are there for guests to do?</h3>
                                <h3>Does the place have any unique features, 
                                    or special touches you consider to be
                                    essential to the guests overall experience?
                                </h3>
                                <h3>What's the most frequent compliment guests give this place?</h3>
                                <h3>Have you had any guests return?</h3>
                                <h3>Did you furnish the stay with any products you'd recommened to other hosts?</h3>
                                <h3>Do you host other stays or experinces on airbnb?</h3>
                                
                                <div>
                                Great dining options
                                Near beach, ocean or harbor
                                Nearby waters sports kayak, sailing, boating, fishing, etc...
                                Neary pro sports arena
                                Peace and quiet
                                Swimming pool
                                Enjoying nature
                                Hiking
                                Winter sports
                                Sightseeing
                                Beautiful views
                                Privacy
                                Stylish, designer decor
                                Walk to downtown, local scene
                                Yard games
                                Outdoor space
                                Game room
                                Gourmet kitchen
                                Family fun
                                Historic area
                                Pets welcome
                                Nomad lifestyle, tiny home community
                                Wedding venues
                                Concerts and events
                                Breweries or vineyards
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-row class="my-0 py-0">
                    <v-col class="shrink">
                        <v-btn icon @click="prevItem" title="last" v-if="hasPrev">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col> 
                        <v-row no-gutters justify="center" class="flex-nowrap">
                            <v-col class="text-center shrink" cols="auto">
                                <v-btn v-if="item.Instagram" rounded outlined :large="btnLarge" :small="btnSmall" :href="'https://www.instagram.com/' + item.Instagram" target="_new">
                                    <v-tooltip top color="black">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">mdi-instagram</v-icon>
                                        </template>
                                        <span>{{ item.Instagram }}</span>
                                    </v-tooltip>
                                </v-btn>
                                <v-btn v-if="item.YouTube" rounded outlined :large="btnLarge" :small="btnSmall" :href="'https://youtube.com/' + item.YouTube" target="_new" class="mx-1">
                                    <v-tooltip top color="black">
                                        <template v-slot:activator="{ on }">
                                            <v-icon class="mr-1" v-on="on">mdi-youtube-tv</v-icon>
                                        </template>
                                        <span>{{ item.YouTube }}</span>
                                    </v-tooltip>
                                </v-btn>
                            </v-col>
                            <v-col class="text-center shrink mx-1" cols="auto">
                                <v-btn rounded outlined :large="btnLarge" :small="btnSmall" :href="item.URL" target="_new" color="primary" title="airbnb">
                                    {{ item.SimpleUrl }} 
                                    <img class="ml-1" :src="item.IconUrl" :style="{ height: '20px'}" />
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn icon @click="nextItem" title="next" v-if="hasNext">
                            <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import MapboxMap from '@/components/MapboxMap'
import { TOGGLE_DIALOG_DETAILS, SET_RESOURCE, SET_RESOURCE_ACTIVE } from '@/store/mutation-types'

export default {
    name: 'ModalDetails',
    components: {
        MapboxMap,
    },
    props: {
        modalProps: {
            type: Object,
            default() {
                return {
                    showImage: true,
                    viewName: null,
                }
            },
            required: false
        },
    },
    methods: {
        ...mapMutations({
            setActiveResource: SET_RESOURCE_ACTIVE
        }),
        closeDialog() {
            this.$store.commit(TOGGLE_DIALOG_DETAILS, { view: this.modalProps.viewName, value: false })
            this.$store.commit(SET_RESOURCE, {})
        },
        prevItem () {
            const prev = this.resources[this.modalProps.viewName][this.idx - 1]
            this.setActiveResource(prev.id)
        },
        nextItem () {
            const next = this.resources[this.modalProps.viewName][this.idx + 1]
            this.setActiveResource(next.id)
        }
    },
    computed: {
        ...mapState({
            dialogDetails: state => state.resource.dialogDetails,
            resources: state => state.resource.resourcesByView,
        }),
        ...mapGetters([
            'getActiveResource',
            'getActiveResourceIndex',
        ]),
        item() {
            return this.getActiveResource(this.modalProps.viewName)
        },
        idx() {
            return this.getActiveResourceIndex(this.modalProps.viewName)
        },
        dialogWidth () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 370
                case 'sm': return 600
                case 'md': return 700
                case 'lg': return 800
                case 'xl': return 970
                default: return 600
            }
        },
        imgHeight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 200
                case 'sm': return 230
                case 'md': return 260
                case 'lg': return 280
                case 'xl': return 330
                default: return 260
            }
        },
        btnSmall () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return true
                case 'sm': return true
                case 'md': return true
                default: return false
            }
        },
        btnLarge () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xl': return true
                default: return false
            }
        },
        hasPrev () {
            return this.idx > 0
        },
        hasNext () {
            return this.resources[this.modalProps.viewName] && (this.idx <= this.resources[this.modalProps.viewName].length - 1)
        },
    },
}
</script>
